import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kqexpcjcr9: FaireBrandEntity = {
  token: "b_kqexpcjcr9",
  type: "brand",
  name: "K2A Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/1ffa6e2fc5d8efc75d0501e63a5f7a3cdd0fac5679c5bdb5995765db4cf92146.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2dd908e241d0367ec726889584da1d6a9ae18621f962c8154c68c2cf47c814bc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1ffa6e2fc5d8efc75d0501e63a5f7a3cdd0fac5679c5bdb5995765db4cf92146.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2dd908e241d0367ec726889584da1d6a9ae18621f962c8154c68c2cf47c814bc.png",
  location: "Simi Valley\t\t, CA, USA",
  minimumOrderDollars: 36,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "At K2A, we believe in the power of play. Founded with a passion for creating joy, our mission is to design high-quality, innovative plush toys and novelty products that spark imagination and bring people together.\n\nOur journey began with a simple idea: to make everyday moments magical. With years of experience in wholesale and retail, we saw an opportunity to craft products that resonate with all ages—whether it's a child clutching their favorite plush at bedtime or a collector adding a new piece to their cherished lineup.\n\nWe work closely with manufacturer sales rep groups, industry leaders, mass-market and specialty retailers to ensure our products reach the hands of those who love them most. From sourcing the finest materials to collaborating with top designers, we prioritize quality, creativity, and affordability in everything we do.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.506Z",
    importedBy: "entity-db-cli",
  },
};
